import {Injectable} from '@angular/core';
import {Router, NavigationStart} from '@angular/router';
import {Observable} from 'rxjs';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class LoaderService {
  private subject = new Subject<any>();
  private keepAfterNavigationChange = true;

  constructor(private router:Router) {
    // clear alert message on route change
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterNavigationChange) {
          // only keep for a single location change
          this.keepAfterNavigationChange = false;
        } else {
          // clear alert
          this.subject.next();
        }
      }
    });
  }

  loading(_isLoading:boolean) {
    this.subject.next(_isLoading);
  }

  isLoading():Observable<any> {
    return this.subject.asObservable();
  }

}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/services/loader.service.ts